// extracted by mini-css-extract-plugin
export default {"paper":"NavigationPopover_paper__2vZDy"};